const manilaCalendar = new Intl.DateTimeFormat("en-CA", { timeZone: "Asia/Manila", year: "numeric", month: "2-digit", day: "2-digit" });

export function changelogToday(now = new Date()) {
  const parts = manilaCalendar.formatToParts(now);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? "";
  return `${part("year")}-${part("month")}-${part("day")}`;
}

/** Only the current public snapshot can preserve a historical release date;
 * a previously saved private draft does not create that exception. */
export function allowedReleaseDate(value: string, publishedDate: string | undefined, today = changelogToday()) {
  return value >= today || (!!publishedDate && value === publishedDate);
}
